<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Equipaje</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 45px; font-weight:900; text-align: center; text-transform: uppercase;">{{boleto.paradero_origen+' - '+boleto.paradero_destino}}</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">No. de Pase: {{ boleto.id }}</pre>
          <pre style="padding-bottom: 4px; font-family: 'Montserrat', sans-serif; font-size: 28px; font-weight:900; text-align: center; text-transform: uppercase;">Nombre Pasajero:</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 28px; font-weight:900; text-align: center; text-transform: uppercase;">{{ boleto.nombre_pasajero }}</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Fecha Salida: {{ boleto.fecha_salida | moment('DD-MM-YYYY') }}</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Hora Salida: {{ boleto.fecha_salida | moment('HH:mm') }} HRS</pre>
          <!--
          <table  style="border-collapse: collapse; width: 100%; font-size: 32px; text-align: left;">  
            <tr>    
              <th style="padding: 2px; text-align: left; background-color: white;"></th> 
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:600;">Pieza equipaje: <span style="text-transform: uppercase; font-weight:800;">#{{equipaje.id}}</span></td>
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">Boleto: <span style="text-transform: uppercase; font-weight:800;">#{{equipaje.boleto_id}}</span></td>  
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">Subida: <span style="text-transform: uppercase; font-weight:800;">{{boleto.paradero_origen}}</span></td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">Bajada: <span style="text-transform: uppercase; font-weight:800;">{{boleto.paradero_destino}}</span></td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">Fecha/Hora de salida: <span style="text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('DD-MM-YYYY hh:mm')}} HRS</span></td>   
            </tr>  
            <tr>    
              <td style="padding: 2px; font-weight:600;">Pasajero: <span style="text-transform: uppercase; font-weight:800;">{{ boleto.nombre_pasajero }}</span></td>   
            </tr>  
          </table>
          -->
          <!--<p style="border: 1px solid #ddd;  padding: 8px; font-size: 18px;">{{user.agencia_activa +' - '+ user.username +' -'}} <span>{{ equipaje.created_at | moment('DD-MM-YYYY HH:mm') }}</span></p>-->
        </body>
      </html>
</template>
<script>
export default {
  props: {
    boleto: {required: false},
    equipaje: {required: false},
    user: {required: false}
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>
<style scoped> 
</style>